import React from 'react'
import NavSimulador from '../components/Simulador'

const Simulador = () => {
  return (
    <NavSimulador />
  )
}

export default Simulador